import { setSelectedMenubarIconId } from '@/features/app/slices';
import { getRightSidebarMenuOptionId } from '@/features/app/utils';
import { requestOpenChat } from '@/features/chat-stream/slices';
import type { ChatOpenChannelPayload } from '@/features/chat-stream/types';
import { dispatch } from '@/stores';

import { requestOpenCustomChat } from '../slices';
import type { CustomChatOpenChannelPayload } from '../types';

const CHAT_MENU_ID =
  getRightSidebarMenuOptionId('chat') ||
  getRightSidebarMenuOptionId('custom-chat');
const CUSTOM_CHAT_MENU_ID = getRightSidebarMenuOptionId('custom-chat');

const buildRequestId = (prefix: string, id: number | string) =>
  `${prefix}_${id}_${Date.now()}_${Math.round(Math.random() * 100000)}`;

export const openStreamDashboardChatRequest = (
  payload: ChatOpenChannelPayload,
  requestIdPrefix: string,
  requestIdSource: number | string
) => {
  dispatch(setSelectedMenubarIconId(CHAT_MENU_ID));
  dispatch(
    requestOpenChat({
      ...payload,
      requestId: buildRequestId(requestIdPrefix, requestIdSource),
    })
  );
};

export const openCustomDashboardChatRequest = (
  payload: CustomChatOpenChannelPayload,
  requestIdPrefix: string,
  requestIdSource: number | string
) => {
  dispatch(setSelectedMenubarIconId(CUSTOM_CHAT_MENU_ID));
  dispatch(
    requestOpenCustomChat({
      ...payload,
      requestId: buildRequestId(requestIdPrefix, requestIdSource),
    })
  );
};

export const openDashboardChatRequest = openStreamDashboardChatRequest;
